import type { ListItem } from "../../components/List/List"

export abstract class MemoryClass<T> {
  listData: T[] = []

  abstract setList(items: T[]): void

  abstract getListCards(all: boolean): any

  abstract getCard(ss: T, count: number): ListItem

  protected abstract getItemId(item: T): number

  protected abstract cloneEntity(item: T): T

  findById = (id: number): T | null => {
    const item = this.listData.find((e) => this.getItemId(e) === id)

    return item ? this.cloneEntity(item) : null
  }

  getByIds = (ids: number[]): T[] => {
    return this.listData.filter((e) => ids.includes(this.getItemId(e))).map((item) => this.cloneEntity(item))
  }

  getAll = (): T[] => {
    return this.listData.map((item) => this.cloneEntity(item))
  }

  getCardById(id: number): ListItem | null {
    const item = this.listData.find((e) => this.getItemId(e) === id)

    return item ? this.getCard(item, 0) : null
  }
}
